import EventEmitter from 'eventemitter3'
import { get, set } from 'lodash'

export default () => {
  const eventEmitter = new EventEmitter()
  const data = {
    initialValues: {},
    values: {},
  }

  return {
    setData(key, value) {
      set(data, key, value)
    },
    getData(key) {
      get(data, key)
    },

    setValues(values) {
      data.values = values
      eventEmitter.emit('setValues', values)
    },
    getValues() {
      return data.values
    },
    resetValues() {
      data.values = { ...data.initialValues }
      eventEmitter.emit('setValues', data.values)
    },
    setValue(name, value) {
      data.values = data.values || {}
      data.values[name] = value
      eventEmitter.emit('setValue', name, value)
    },
    getValue(name) {
      return data.values?.[name]
    },

    on: (eventName, callback) => {
      eventEmitter.on(eventName, callback)
    },

    emit: (...args) => {
      eventEmitter.emit(...args)
    },

    off: (...args) => {
      eventEmitter.removeListener(...args)
    },
  }
}
